"use client"

import { motion } from "framer-motion"
import CutEmeraldCard from "./cut-emerald-card"
import { cutEmeralds } from "./cut-emeralds-data"

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export default function CutEmeraldsGrid() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <motion.div
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {cutEmeralds.map((emerald) => (
          <CutEmeraldCard key={emerald.id} emerald={emerald} />
        ))}
      </motion.div>
    </div>
  )
}
